import * as React from 'react';
import { NavLink, useLocation } from "react-router-dom";
import '../static/Navbar.css';
import { Box, MenuItem, Menu, Fade, IconButton, Tooltip } from '@mui/material';
import { Menu as MenuIcon, Close as CloseIcon, Phone as PhoneIcon, AccountCircle as AccountCircleIcon } from '@mui/icons-material';
import Logo from '../images/logo.png';

const navLinks = [{to:'/AboutUs',text:'About Us'},{to:'/Services',text:'Services'},{to:'/Resources',text:'Resources'},{to:'/Contact',text:'Contact'},{to:'/Careers',text:'Careers'}];

const Navbar = () => {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [isSticky, setIsSticky] = React.useState(false);
    const [isScrolled, setIsScrolled] = React.useState(false);
    const [navHeight, setNavHeight] = React.useState(0);
    const navRef = React.useRef(null);
    const location = useLocation();

    const handleOpenNavMenu = (e) => setAnchorElNav(e.currentTarget);
    const handleCloseNavMenu = () => setAnchorElNav(null);

    React.useEffect(() => { handleCloseNavMenu(); }, [location]);
    React.useEffect(() => { if (navRef.current) setNavHeight(navRef.current.offsetHeight); }, []);
    React.useEffect(() => {
        const sentinel = document.getElementById('nav-sentinel');
        if (!sentinel) return;
        const observer = new IntersectionObserver(([entry]) => {
            setIsSticky(!entry.isIntersecting);
            setIsScrolled(window.scrollY > 50);
        }, { root: null, threshold: 0, rootMargin: '-1px 0px 0px 0px' });
        observer.observe(sentinel);
        return () => observer.disconnect();
    }, []);
    React.useEffect(() => {
        const handleScroll = () => setIsScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const navStyle = {
        position: isSticky ? 'fixed' : 'relative',
        top: isSticky ? 0 : 'auto',
        backgroundColor: isScrolled ? '#2c3e50' : '#2c3e50',
        boxShadow: isScrolled ? '0 4px 12px rgba(0,0,0,0.15)' : 'none',
        backdropFilter: isScrolled ? 'blur(10px)' : 'none',
    };

    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
    const isActiveLink = ({ isActive }) => ({
        color: isActive ? '#ffffff' : 'rgba(255,255,255,0.8)',
        borderBottom: isActive ? '2px solid #fff' : '2px solid transparent',
        fontWeight: isActive ? 600 : 500,
    });

    return (
        <div>
            <Box className="top-bar">
                <div className="top-bar-content">
                    <div className="logo-container">
                        <NavLink to="/" onClick={scrollToTop} className="logo-link">
                            <img src={Logo} alt="247 Assure Care Logo" className="logo-img" />
                            <span className="company-name">24/7 Assure Care</span>
                        </NavLink>
                    </div>
                    <div className="phone-container">
                        <Tooltip title="Call us at 847-483-8999">
                            <a href="tel:8474838999" className="phone-link-top">
                                <PhoneIcon className="phone-icon" />
                                <span>847-483-8999</span>
                            </a>
                        </Tooltip>
                    </div>
                </div>
            </Box>

            <div id="nav-sentinel" className="nav-sentinel" />
            <nav ref={navRef} className="main-nav" style={navStyle} aria-label="Main navigation">
                <Box className="nav-container">
                    <div className="nav-content">
                        {isSticky && (
                            <div className="sticky-logo">
                                <NavLink to="/" onClick={scrollToTop} className="sticky-logo-link">
                                    <img src={Logo} alt="247 Assure Care Logo" className="sticky-logo-img" />
                                    <span className='h5 mt-1'>24/7 Assure Care</span>
                                </NavLink>
                            </div>
                        )}

                        <div className="nav-links-center">
                            {navLinks.map((link,i)=>(
                                <NavLink key={i} to={link.to} onClick={scrollToTop} style={isActiveLink} className="nav-link">{link.text}</NavLink>
                            ))}
                        </div>

                        <div className="nav-right-section">
                            {isSticky && (
                                <a href="tel:8474838999" className="phone-link-sticky">
                                    <PhoneIcon />
                                    <span className="phone-number-sticky h6 mt-2">847-483-8999</span>
                                </a>
                            )}

                            <NavLink to="/Login" onClick={scrollToTop} className="login-button">
                                <AccountCircleIcon className="login-icon" /> Log In
                            </NavLink>
                        </div>
                    </div>
                </Box>

                <Box className="mobile-nav-container">
                    <div className="mobile-logo-section">
                        <NavLink to="/" onClick={scrollToTop}>
                            <img src={Logo} alt="247 Assure Care Logo" className="mobile-logo-img" />
                        </NavLink>
                        <NavLink to="/" onClick={scrollToTop} className="mobile-company-name">24/7 Assure Care</NavLink>
                    </div>
                    
                    <div className="mobile-nav-right">
                        <a href="tel:8474838999" className="mobile-phone-link"><PhoneIcon /></a>
                        
                        <IconButton aria-label="Open navigation menu" aria-controls="menu-appbar" aria-haspopup="true" onClick={handleOpenNavMenu} className="mobile-menu-button">
                            {anchorElNav ? <CloseIcon /> : <MenuIcon />}
                        </IconButton>

                        <Menu id="menu-appbar" anchorEl={anchorElNav} open={Boolean(anchorElNav)} onClose={handleCloseNavMenu} TransitionComponent={Fade}
                            MenuListProps={{className: 'mobile-menu-list'}} className="mobile-menu">
                            {navLinks.map((link,index)=>(
                                <MenuItem key={index} onClick={handleCloseNavMenu} className="mobile-menu-item">
                                    <NavLink to={link.to} onClick={scrollToTop} style={isActiveLink} className="mobile-nav-link">{link.text}</NavLink>
                                </MenuItem>
                            ))}
                            <MenuItem onClick={handleCloseNavMenu} className="mobile-menu-login-item">
                                <NavLink to="/Login" onClick={scrollToTop} className="mobile-login-link">
                                    <AccountCircleIcon className="mobile-login-icon" /> Log In
                                </NavLink>
                            </MenuItem>
                        </Menu>
                    </div>
                </Box>
            </nav>

            {isSticky && <div style={{height:navHeight}} />}
        </div>
    );
};

export default Navbar;